export const GENERAL_SCHEDULE_SCHEMA_URL = 'https://heygirl.cutestperson.com/assets/public/schemas/scheduleschema.json' as const;
export const GENERAL_SCHEDULE_COMPONENT_TYPE = 'GeneralSchedule' as const;
